export class CreateEscritoRequest {
  descripcion!: string | null;  // Descripción del escrito (nullable)
  titulo!: string | null;  // Título del escrito (nullable)
  cuerpoHTML!: string | null;  // Cuerpo en HTML del escrito (nullable)
  fechaCreacion!: string;  // Fecha de creación en formato date-time
  idEstadoEscrito!: number | null;  // ID del estado del escrito (nullable)
  idExpediente!: number | null;  // ID del expediente (nullable)
  idTipoEscrito!: number | null;  // ID del tipo de escrito (nullable)


}
